import { obtenerFechaActual, obtenerHoraActual, tratoClienteConcesionaria } from "../../utilities/utils";
import { clienteAxiosSaaS } from "../axios";

export const sendMailContactoCliente = (stateData, textoPrincipal = "Agradecemos tu interés, tus datos han sido canalizados.") => {
  const urlAvisoDePrivacidad = process.env.REACT_APP_AVISO_PRIVACIDAD;

  const tratoMailCliente = stateData.tratamiento === "Sr" ? "Estimado" : "Estimada";

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_CONTACTO_CORREO_PERSONAL} <${process.env.REACT_APP_CONTACTO_CORREO_FROM}>`,
          subject: stateData.asunto,
          to: [stateData.email.trim()],
          cc: [],
          bcc: process.env.REACT_APP_CONTACTO_CORREO_CCO_ICDC.split(","),
          html:
            `
            <!doctype html>
            <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

            <head>
              <title>
              </title>
              <!--[if !mso]><!-->
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <!--<![endif]-->
              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <style type="text/css">
                #outlook a {
                  padding: 0;
                }

                body {
                  margin: 0;
                  padding: 0;
                  -webkit-text-size-adjust: 100%;
                  -ms-text-size-adjust: 100%;
                }

                table,
                td {
                  border-collapse: collapse;
                  mso-table-lspace: 0pt;
                  mso-table-rspace: 0pt;
                }

                img {
                  border: 0;
                  height: auto;
                  line-height: 100%;
                  outline: none;
                  text-decoration: none;
                  -ms-interpolation-mode: bicubic;
                }

                p {
                  display: block;
                  margin: 13px 0;
                }
              </style>
              <!--[if mso]>
                    <noscript>
                    <xml>
                    <o:OfficeDocumentSettings>
                      <o:AllowPNG/>
                      <o:PixelsPerInch>96</o:PixelsPerInch>
                    </o:OfficeDocumentSettings>
                    </xml>
                    </noscript>
                    <![endif]-->
              <!--[if lte mso 11]>
                    <style type="text/css">
                      .mj-outlook-group-fix { width:100% !important; }
                    </style>
                    <![endif]-->
              <style type="text/css">
                @media only screen and (min-width:480px) {
                  .mj-column-per-100 {
                    width: 100% !important;
                    max-width: 100%;
                  }
                }
              </style>
              <style media="screen and (min-width:480px)">
                .moz-text-html .mj-column-per-100 {
                  width: 100% !important;
                  max-width: 100%;
                }
              </style>
              <style type="text/css">
                @media only screen and (max-width:480px) {
                  table.mj-full-width-mobile {
                    width: 100% !important;
                  }

                  td.mj-full-width-mobile {
                    width: auto !important;
                  }
                }
              </style>
            </head>

            <body style="word-spacing:normal;">
              <div style="">
                <!-- Header con logo -->
                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                <div style="margin:0px auto;max-width:600px;">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                          <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                                      <tbody>
                                        <tr>
                                          <td style="width:76px;">
                                            <img height="auto" src="https://www.appsaudi.com.mx/resources/images/logo_audi.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="76" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                                      <tbody>
                                        <tr>
                                          <td style="width:550px;">
                                            <img height="auto" src="https://www.appsaudi.com.mx/resources/images/formsSalesforce/${stateData.imgName}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="550" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--[if mso | IE]></td></tr></table><![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
                <!-- Cuerpo Texto -->
                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                <div style="margin:0px auto;max-width:600px;">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                          <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:17px;line-height:1;text-align:left;color:#000000;"><strong>${tratoMailCliente} ${stateData.nombre} ${stateData.apellidoPaterno}</strong></div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size:0px;word-break:break-word;">
                                    <div style="height:20px;line-height:20px;">&#8202;</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:16px;line-height:1.5;text-align:left;color:#000000;">${textoPrincipal}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:16px;line-height:1.5;text-align:left;color:#000000;">
                                      Si existe alguna información adicional que desees compartirnos ponemos a tu disposición nuestra línea de atención a clientes: 800 849 23 83.
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:16px;line-height:22px;text-align:left;color:#000000;">Atentamente, <br /> Audi de México</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size:0px;word-break:break-word;">
                                    <div style="height:30px;line-height:30px;">&#8202;</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:18px;line-height:1;text-align:left;color:#000000;"><strong>¡Gracias por tu preferencia!</strong></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--[if mso | IE]></td></tr></table><![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
                <!-- Footer -->
                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                <div style="margin:0px auto;max-width:600px;">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                          <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <p style="border-top:solid 1px #757575;font-size:1px;margin:0px auto;width:100%;">
                                    </p>
                                    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #757575;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
            </td></tr></table><![endif]-->
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                    <div style="font-family:helvetica;font-size:10px;line-height:1.5;text-align:left;color:#757575;">Este mensaje se envió a <a href='mailto:correo_cliente@mail.com' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>${stateData.email.trim()}</a> <br />
                                      <a href='${urlAvisoDePrivacidad}' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;'>Política de Privacidad</a>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--[if mso | IE]></td></tr></table><![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </div>
            </body>

            </html>
            `},
      });
      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      console.log("Error correo: ", error);
      reject("Error en petición a API - Correo Cliente");
    }
  });
};

export const sendMailContactoClienteQuejas = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento de Costumer Care para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

export const sendMailContactoClienteSugerencias = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento correspondiente para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

export const sendMailContactoClienteInformacion = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento correspondiente para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

export const sendMailContactoClienteRH = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento correspondiente para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

export const sendMailContactoClienteOtro = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento correspondiente para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

export const sendMailContactoClientePostVenta = (stateData) => {
  const textoPrincipal = "Agradecemos tus comentarios. Tu información ha sido canalizada a nuestro departamento correspondiente para tu atención. En breve nos estaremos comunicando contigo por los medios que nos has proporcionado.";
  return sendMailContactoCliente(stateData, textoPrincipal);
}

const sendMailContactoConcesionariaBase = (asunto = "", stateData, infoMail) => {
  const urlAvisoDePrivacidad =
    "https://www.audi.com.mx/mx/web/es.html#layer=/mx/web/es/tools/navigation/layer/legal.html";

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_CONTACTO_CORREO_PERSONAL} <${process.env.REACT_APP_CONTACTO_CORREO_FROM}>`,
          subject: asunto,
          to: [stateData.contactos[0]],
          cc: stateData.contactos.splice(1),
          bcc: process.env.REACT_APP_CONTACTO_CORREO_CCO_ICDC.split(","),
          html:
            `<!doctype html>
                        <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
                        
                        <head>
                          <title>
                          </title>
                          <!--[if !mso]><!-->
                          <meta http-equiv="X-UA-Compatible" content="IE=edge">
                          <!--<![endif]-->
                          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                          <meta name="viewport" content="width=device-width, initial-scale=1">
                          <style type="text/css">
                            #outlook a {
                              padding: 0;
                            }
                        
                            body {
                              margin: 0;
                              padding: 0;
                              -webkit-text-size-adjust: 100%;
                              -ms-text-size-adjust: 100%;
                            }
                        
                            table,
                            td {
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            }
                        
                            img {
                              border: 0;
                              height: auto;
                              line-height: 100%;
                              outline: none;
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                            }
                        
                            p {
                              display: block;
                              margin: 13px 0;
                            }
                          </style>
                          <!--[if mso]>
                                <noscript>
                                <xml>
                                <o:OfficeDocumentSettings>
                                  <o:AllowPNG/>
                                  <o:PixelsPerInch>96</o:PixelsPerInch>
                                </o:OfficeDocumentSettings>
                                </xml>
                                </noscript>
                                <![endif]-->
                          <!--[if lte mso 11]>
                                <style type="text/css">
                                  .mj-outlook-group-fix { width:100% !important; }
                                </style>
                                <![endif]-->
                          <style type="text/css">
                            @media only screen and (min-width:480px) {
                              .mj-column-per-100 {
                                width: 100% !important;
                                max-width: 100%;
                              }
                            }
                          </style>
                          <style media="screen and (min-width:480px)">
                            .moz-text-html .mj-column-per-100 {
                              width: 100% !important;
                              max-width: 100%;
                            }
                          </style>
                          <style type="text/css">
                            @media only screen and (max-width:480px) {
                              table.mj-full-width-mobile {
                                width: 100% !important;
                              }
                        
                              td.mj-full-width-mobile {
                                width: auto !important;
                              }
                            }
                          </style>
                        </head>
                        
                        <body style="word-spacing:normal;">
                          <div style="">
                            <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                            <div style="margin:0px auto;max-width:600px;">
                              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                                <tbody>
                                  <tr>
                                    <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                                      <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                                      <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                                                  <tbody>
                                                    <tr>
                                                      <td style="width:100px;">
                                                        <img height="auto" src="https://www.appsaudi.com.mx/resources/images/logo_audi.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100" />
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" style="font-size:0px;padding:10px 25px;padding-top:30px;padding-right:40px;padding-bottom:15px;padding-left:40px;word-break:break-word;">
                                                <div style="font-family:AudiType,sans-serif;font-size:20px;font-weight:bold;line-height:1;text-align:left;color:#000000;">Has recibido una nueva solicitud: "${asunto}"</div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" style="font-size:0px;padding:10px 25px;padding-top:15px;padding-right:40px;padding-bottom:15px;padding-left:40px;word-break:break-word;">
                                                <div style="font-family:AudiType,sans-serif;font-size:16px;font-weight:normal;line-height:20px;text-align:left;color:#000000;">
                                                  <p> 
                                                  ${infoMail}
                                                  </p>
                                                  <p> Atentamente, <br /> Audi de México </p>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                                <p style="border-top:solid 1px lightgrey;font-size:1px;margin:0px auto;width:100%;">
                                                </p>
                                                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px lightgrey;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
                        </td></tr></table><![endif]-->
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" style="font-size:0px;padding:10px 25px;padding-top:5px;padding-right:40px;padding-bottom:15px;padding-left:40px;word-break:break-word;">
                                                <div style="font-family:AudiType,sans-serif;font-size:12px;font-weight:normal;line-height:1;text-align:left;color:#757575;">
                                                  <p>Este mensaje se envió a <strong style="color:#000">${stateData.contactos[0]}</strong></p>
                                                  <a href="${urlAvisoDePrivacidad}">Política de Privacidad</a>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <!--[if mso | IE]></td></tr></table><![endif]-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <!--[if mso | IE]></td></tr></table><![endif]-->
                          </div>
                        </body>
                        
                        </html>`,
        },
      });
      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      console.log("Error correo: ", error);
      reject("Error en petición a API - Concesionario");
    }
  });
};

export const sendMailContactoConcesionariaQuejas = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br /> 
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Concesionaria Preferida: ${stateData.concesionariaPreferida}<br /> 
    Número de Concesionaria: ${stateData.numeroConcesionaria}<br />
    Vehículo actual: ${stateData.vehiculoInteres === "" ? "Sin selección" : stateData.vehiculoInteres} <br />
    Número de serie: ${stateData.vin === "" ? "Sin número de serie" : stateData.vin}<br />
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_QUEJA, stateData, infoMail);
}

export const sendMailContactoConcesionariaSugerencias = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br /> 
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Concesionaria Preferida: ${stateData.concesionariaPreferida}<br /> 
    Número de Concesionaria: ${stateData.numeroConcesionaria}<br />
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_SUGERENCIA, stateData, infoMail);
}

export const sendMailContactoConcesionariaInformacion = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br /> 
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Concesionaria Preferida: ${stateData.concesionariaPreferida}<br /> 
    Número de Concesionaria: ${stateData.numeroConcesionaria}<br />
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_INFORMACION, stateData, infoMail);
}

export const sendMailContactoConcesionariaRH = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br /> 
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_RH, stateData, infoMail);
}

export const sendMailContactoConcesionariaOtro = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br />   
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_OTRO, stateData, infoMail);
}

/**
 * Layout de correo propio para Audi Driving Experience (no reutiliza la plantilla
 * genérica de sendMailContactoCliente): header con la imagen de portada de la
 * campaña en vez del logo genérico, saludo neutro (no depende de tratamiento
 * porque este formulario no pide Sr./Sra.).
 */
export const sendMailDrivingExperienceCliente = (stateData) => {
  const urlAvisoDePrivacidad = process.env.REACT_APP_AVISO_PRIVACIDAD;
  const imgHeader = `${process.env.REACT_APP_RESOURCES_IMAGES_PATH}formsSalesforce/${stateData.imgName}`;

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_PERSONAL} <${process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_FROM}>`,
          subject: stateData.asunto,
          to: [stateData.email.trim()],
          cc: [],
          bcc: process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_CCO_ICDC.split(","),
          html: `
            <!doctype html>
            <html xmlns="http://www.w3.org/1999/xhtml">
            <head>
              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <title></title>
            </head>
            <body style="margin:0;padding:0;background-color:#f2f2f2;">
              <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f2f2f2;">
                <tr>
                  <td align="center">
                    <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="width:600px;max-width:600px;background-color:#ffffff;">
                      <tr>
                        <td style="background-color:#000000;padding:0;">
                          <img src="${imgHeader}" width="600" alt="Audi Driving Experience" style="display:block;width:100%;height:auto;border:0;" />
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:16px 25px 0 25px;">
                          <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                            <tr><td style="width:70px;"><img src="https://www.appsaudi.com.mx/resources/images/logo_audi.png" width="60" alt="Audi" style="display:block;border:0;" /></td></tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:24px 25px 8px 25px;font-family:helvetica,Arial,sans-serif;">
                          <div style="font-size:20px;line-height:1.3;color:#000000;font-weight:bold;">Hola ${stateData.nombre} ${stateData.apellidoPaterno},</div>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:8px 25px 0 25px;font-family:helvetica,Arial,sans-serif;font-size:16px;line-height:1.5;color:#000000;">
                          Gracias por su interés en las experiencias de manejo internacionales de Audi Driving Experience.
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:16px 25px 0 25px;font-family:helvetica,Arial,sans-serif;font-size:16px;line-height:1.5;color:#000000;">
                          Hemos recibido su solicitud y en breve nos pondremos en contacto con usted para resolver sus dudas y proporcionarle toda la información que requiera.
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:16px 25px 0 25px;font-family:helvetica,Arial,sans-serif;font-size:16px;line-height:1.5;color:#000000;">
                          Si requiere información adicional, le invitamos a comunicarse con nuestro Centro de Atención a Clientes al 800 849 23 83.
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:16px 25px 24px 25px;font-family:helvetica,Arial,sans-serif;font-size:16px;line-height:1.5;color:#000000;">
                          Atentamente,<br />Audi de México
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:0 25px;"><div style="border-top:1px solid #757575;font-size:1px;line-height:1px;">&nbsp;</div></td>
                      </tr>
                      <tr>
                        <td style="padding:12px 25px 20px 25px;font-family:helvetica,Arial,sans-serif;font-size:10px;line-height:1.5;color:#757575;">
                          Este mensaje se envió a <a href="mailto:${stateData.email.trim()}" style="color:#000000;text-decoration:none;font-weight:bold;">${stateData.email.trim()}</a><br />
                          <a href="${urlAvisoDePrivacidad}" target="_blank" rel="noreferrer" style="color:#000000;text-decoration:none;border-bottom:1px solid #000000;">Política de Privacidad</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            </html>
          `,
        },
      });
      resolve(respuesta);
    } catch (error) {
      console.log("Error correo: ", error);
      reject("Error en petición a API - Correo Cliente Driving Experience");
    }
  });
};

export const sendMailDrivingExperienceConcesionaria = (stateData) => {
  const urlAvisoDePrivacidad =
    "https://www.audi.com.mx/mx/web/es.html#layer=/mx/web/es/tools/navigation/layer/legal.html";
  const asunto = process.env.REACT_APP_DRIVING_EXPERIENCE_ASUNTO;

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_PERSONAL} <${process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_FROM}>`,
          subject: asunto,
          to: [stateData.contactos[0]],
          cc: stateData.contactos.slice(1),
          bcc: process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_CCO_ICDC.split(","),
          html: `
            <!doctype html>
            <html xmlns="http://www.w3.org/1999/xhtml">
            <head>
              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <title></title>
            </head>
            <body style="margin:0;padding:0;background-color:#f2f2f2;">
              <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f2f2f2;">
                <tr>
                  <td align="center">
                    <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="width:600px;max-width:600px;background-color:#ffffff;">
                      <tr>
                        <td align="center" style="background-color:#000000;padding:14px 25px;text-align:center;">
                          <img src="https://www.appsaudi.com.mx/resources/images/logo_audi_white.png" width="70" alt="Audi" style="display:block;margin:0 auto;border:0;" />
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:24px 25px 4px 25px;font-family:AudiType,helvetica,Arial,sans-serif;font-size:20px;font-weight:bold;color:#000000;">
                          Nueva solicitud - Audi Driving Experience
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:8px 25px 16px 25px;font-family:helvetica,Arial,sans-serif;font-size:14px;color:#000000;">
                          Se recibió una nueva solicitud de contacto a través del formulario de Audi Driving Experience.
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:0 25px;">
                          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;font-family:helvetica,Arial,sans-serif;font-size:14px;color:#000000;">
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;width:35%;color:#757575;">Nombre</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.nombre} ${stateData.apellidoPaterno}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;">Teléfono</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.telefono}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;">Móvil</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.celular}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;">E-mail</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.email}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;vertical-align:top;">Mensaje</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;word-break:break-word;">${(stateData.descripcion || "").replace(/\n/g, "<br />")}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;">Aviso de Privacidad</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.avisoPrivacidad ? "Sí" : "No"}</td></tr>
                            <tr><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;color:#757575;">Términos y Condiciones</td><td style="padding:8px 0;border-bottom:1px solid #e5e5e5;">${stateData.terminosCondiciones ? "Sí" : "No"}</td></tr>
                            <tr><td style="padding:8px 0;color:#757575;">Fecha</td><td style="padding:8px 0;">${obtenerFechaActual()} ${obtenerHoraActual()}</td></tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:20px 25px 0 25px;"><div style="border-top:1px solid lightgrey;font-size:1px;line-height:1px;">&nbsp;</div></td>
                      </tr>
                      <tr>
                        <td style="padding:12px 25px 20px 25px;font-family:helvetica,Arial,sans-serif;font-size:12px;color:#757575;">
                          Este mensaje se envió a <strong style="color:#000000;">${stateData.contactos[0]}</strong><br />
                          <a href="${urlAvisoDePrivacidad}" style="color:#757575;">Política de Privacidad</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            </html>
          `,
        },
      });
      resolve(respuesta);
    } catch (error) {
      console.log("Error correo: ", error);
      reject("Error en petición a API - Concesionaria Driving Experience");
    }
  });
};

export const sendMailContactoConcesionariaPostventa = (stateData) => {
  const tratamiento = tratoClienteConcesionaria(stateData.tratamiento);
  const infoMail = `
    Trato: ${tratamiento} <br />
    Nombre: ${stateData.nombre} <br /> 
    Apellido Paterno: ${stateData.apellidoPaterno}<br /> 
    Telefono: ${stateData.telefono}<br /> 
    Celular: ${stateData.celular}<br /> 
    Email: ${stateData.email}<br /> 
    Ciudad: ${stateData.ciudad}<br /> 
    Provincia: ${stateData.provincia}<br /> 
    Servicio de interés: ${stateData.vehiculoInteres}<br /> 
    Tipo de información requerida: ${stateData.tipoCita}<br /> 
    Descripción: ${stateData.descripcion}<br /> 
    <br />
    Permiso Transferencia de Datos: ${stateData.permisoTransferenciaDatos ? 'Sí' : 'No'}<br /> 
    Fecha: ${obtenerFechaActual()} ${obtenerHoraActual()} <br />
  `;

  return sendMailContactoConcesionariaBase(process.env.REACT_APP_CONTACTO_ASUNTO_POSTVENTA, stateData, infoMail);
}
